<div class="custom-dialog" [ngStyle]="{'height': '450px'}">

  <div class="modal-blue-icon modal-icon">
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23 0.5C35.4263 0.5 45.5 10.5736 45.5 23C45.5 35.4263 35.4263 45.5 23 45.5C10.5736 45.5 0.5 35.4263 0.5 23C0.5 10.5736 10.5736 0.5 23 0.5ZM28.5 14.5H17.5C16.3954 14.5 15.5 15.3954 15.5 16.5V29.5C15.5 30.6046 16.3954 31.5 17.5 31.5H28.5C29.6046 31.5 30.5 30.6046 30.5 29.5V16.5C30.5 15.3954 29.6046 14.5 28.5 14.5ZM22.5 25.5V28H20.5V25.5H17.5V23.5H20.5V21H22.5V23.5H25.5V25.5H22.5Z"
        fill="white" />
    </svg>
  </div>

  <div class="modal-title">Change Application State</div>
  <div class="modal-text">Select a new state and provide comments</div>

  <div class="row">
    <div class="col-md-10 offset-md-1">
      <form [formGroup]="changeStateForm">
        <!-- State Dropdown -->
        <div class="form-group">
          <label class="form-label">
            Change State: <span class="text-danger">*</span>
          </label>
          <ng-select
            formControlName="decisionOutcome"
            [items]="stateOptions"
            bindLabel="label"
            bindValue="enumValue"
            placeholder="Select application state..."
            [clearable]="false"
          >
          </ng-select>
          <div
            *ngIf="submitted && changeStateForm.get('decisionOutcome')?.invalid"
            class="text-danger mt-1"
          >
            Please select a state.
          </div>
        </div>

        <!-- Comment Box -->
        <div class="form-group">
          <label class="form-label">
            Comment: <span class="text-danger">*</span>
          </label>
          <textarea
            class="form-control"
            formControlName="comment"
            rows="4"
            placeholder="Enter your comments here (10-10000 characters)..."
          ></textarea>
          <div
            *ngIf="submitted && changeStateForm.get('comment')?.invalid"
            class="text-danger mt-1"
          >
            <span *ngIf="changeStateForm.get('comment')?.errors?.['required']">Comment is required.</span>
            <span *ngIf="changeStateForm.get('comment')?.errors?.['minlength']">Comment must be at least 10 characters.</span>
            <span *ngIf="changeStateForm.get('comment')?.errors?.['maxlength']">Comment must not exceed 10000 characters.</span>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="text-center">
    <button class="btn btn-secondary" (click)="cancel()">CANCEL</button>
    <button class="btn btn-success ml-3" (click)="changeState()">CHANGE STATE</button>
  </div>

</div>
